import { createSelector } from "reselect";

import { ApplicationState } from "../applicationState";
import { ohCaseSelector } from "../crud/ohCase/selectors";

export const taskIdSelector = (state: ApplicationState): string => {
    return state.router.params && state.router.params.taskId;
};

/**
 * @deprecated Only used in OldHealthSurveillanceReviewForm which is deprecated
 */
export const tasksSelector = createSelector(
    ohCaseSelector,
    ohCase => ohCase.tasks
);

export const actionableTasksSelector = (state: ApplicationState) => state.actionableTasks.tasks;

export const TasksTypesSelector = (state: ApplicationState) => state.tasks.taskTypes;

export const actionableTaskSelector = createSelector(
    actionableTasksSelector,
    taskIdSelector,
    (actionableTasks, id) => actionableTasks.find(t => t.id === id)
);

export const taskSelector = createSelector(
    taskIdSelector,
    ohCaseSelector,
    actionableTaskSelector,
    (id, ohCase, actionableTask) => ohCase.tasks ? ohCase.tasks.find(t => t.id === id) : actionableTask
);
